import React, { useState } from "react";
import { Accordion, Card, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import { ArrowDownIcon } from "../assets/Icons";
import thumb from "../../src/assets/images/RemoteAssist.png";

const SimAccordion = ({ items, parentKey = "root", setterFunc = () => {}, selected = [] }) => {
  const [activeKeys, setActiveKeys] = useState([]);

  const getInitials = (title) => {
    const words = title.trim().split(" ");
    const first = words[0]?.[0]?.toUpperCase() || "";
    const second = words[1]?.[0]?.toUpperCase() || "";
    return first + second;
  };

  const handleChecked = (id, checked) => {
    setterFunc((prev) => {
      if (checked) {
        return [...prev, id];
      } else {
        return prev.filter((e) => e != id);
      }
    });
  };

  const findParent = (id, items) => {
    for (const item of items) {
      if (item.id === id) return item;
      if (item.children) {
        const res = findParent(id, item.children);
        if (res) return res;
      }
    }
    return null;
  };

  const getNestedIds = (node) => {
    let ids = [node.id];
    if (node.children) {
      node.children.forEach((child) => {
        ids = ids.concat(child.id);
      });
    }
    return ids;
  };

  const handleSelectAll = (id, checked) => {
    const parentObj = findParent(id, items);
    const nestedIds = getNestedIds(parentObj);
    setterFunc((prev) => {
      if (checked) {
        return [...new Set([...prev, ...nestedIds])];
      } else {
        return prev.filter((e) => !nestedIds.includes(e));
      }
    });
  };

  const handleToggle = (eventKey) => {
    setActiveKeys((prev) => (prev.includes(eventKey) ? prev.filter((key) => key !== eventKey) : [...prev, eventKey]));
  };

  return (
    <Accordion className="accordionhirarchymodal">
      {items.map((item, index) => {
        const eventKey = `${parentKey}-${index}`;
        return (
          <Card key={eventKey}>
            <Card.Header>
              {/* <Accordion.Toggle as={Button} variant="link" eventKey={eventKey}> */}
              <Accordion.Toggle as={Button} variant="link" eventKey={eventKey} onClick={() => handleToggle(eventKey)}>
                <div className="mainaccorheader">
                  <div className="accordionheader d-flex align-items-center">
                    {item.children && item.children.length > 0 && (
                      <div className="icon visible">
                        <span
                          style={{
                            display: "inline-block",
                            transform: activeKeys.includes(eventKey) ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform 0.2s",
                          }}
                        >
                          <ArrowDownIcon />
                        </span>
                      </div>
                    )}
                    <div className="form-check mr-1" onClick={(e) => e.stopPropagation()}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`check-${eventKey}`}
                        checked={selected.includes(item.id)}
                        onChange={(e) => handleChecked(item?.id, e.target.checked)}
                      />
                      <label className="form-check-label" htmlFor={`check-${eventKey}`} />
                    </div>
                    <div className="thumb-or-initial mr-1">
                      {item.avatar ? (
                        <div className="thumbnailgroup">
                          <img src={item.avatar} alt={item.name} />
                        </div>
                      ) : (
                        <div className="groupinitials" style={{ width: "2rem", height: "2rem" }}>
                          {getInitials(item.name)}
                        </div>
                      )}
                    </div>
                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-view">{item.name}</Tooltip>}>
                      <p className="m-0">{item.name}</p>
                    </OverlayTrigger>
                  </div>
                  {item.children &&
                    item.children.length > 0 &&
                    (selected?.includes(item?.id) ? (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSelectAll(item?.id, false);
                        }}
                        className="selectalls"
                      >
                        Unselect All
                      </button>
                    ) : (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSelectAll(item?.id, true);
                        }}
                        className="selectalls"
                      >
                        Select All
                      </button>
                    ))}
                </div>
              </Accordion.Toggle>
            </Card.Header>

            <Accordion.Collapse eventKey={eventKey}>
              <Card.Body>
                {item.children && item.children.length > 0 && (
                  <div className="ml-3">
                    <SimAccordion
                      items={item.children}
                      parentKey={eventKey}
                      setterFunc={setterFunc}
                      selected={selected}
                    />
                  </div>
                )}
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        );
      })}
    </Accordion>
  );
};

const AccordionWrapper = ({ items, setterFunc, selected }) => {
  return <SimAccordion items={[items]} setterFunc={setterFunc} selected={selected} />;
};

export default AccordionWrapper;
